import { StyleSheet } from "@react-pdf/renderer";

const BORDE = "#000";

const celdaBien = { padding: 3, borderRightWidth: 1, borderRightColor: BORDE, fontSize: 8.5 };

const actaStyles = StyleSheet.create({
  page: {
    paddingTop: 92,
    paddingHorizontal: 56,
    paddingBottom: 112,
    fontSize: 9.5,
    fontFamily: "Helvetica",
    color: "#111"
  },
  // Logo ART arriba a la derecha y banner inferior: se repiten en cada página.
  headerLogo: {
    position: "absolute",
    top: 22,
    right: 48,
    width: 118
  },
  footerBanner: {
    position: "absolute",
    bottom: 14,
    left: 30,
    right: 30
  },
  negrita: { fontFamily: "Helvetica-Bold" },
  tituloConvenio: {
    fontFamily: "Helvetica-Bold",
    fontSize: 10,
    textAlign: "center"
  },
  tituloProyecto: {
    fontFamily: "Helvetica-Bold",
    fontSize: 10,
    textAlign: "center",
    marginTop: 3,
    paddingHorizontal: 20
  },
  tituloActa: {
    fontFamily: "Helvetica-Bold",
    fontSize: 10,
    textAlign: "center",
    marginTop: 6,
    marginBottom: 8
  },
  infoTable: {
    borderWidth: 1,
    borderColor: BORDE,
    marginBottom: 14
  },
  infoRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: BORDE,
    minHeight: 20
  },
  infoRowLast: {
    flexDirection: "row",
    minHeight: 20
  },
  infoLabel: {
    width: "48%",
    padding: 4,
    fontFamily: "Helvetica-Bold",
    borderRightWidth: 1,
    borderRightColor: BORDE
  },
  infoValue: {
    width: "52%",
    padding: 4
  },
  tipoEntregaValue: {
    width: "52%",
    flexDirection: "row",
    alignItems: "stretch"
  },
  tipoEntregaTexto: {
    padding: 4,
    width: 52
  },
  tipoEntregaCaja: {
    width: 26,
    padding: 4,
    textAlign: "center",
    borderLeftWidth: 1,
    borderLeftColor: BORDE,
    borderRightWidth: 1,
    borderRightColor: BORDE
  },
  seccionTitulo: {
    fontFamily: "Helvetica-Bold",
    fontSize: 9.5,
    marginTop: 8,
    marginBottom: 5
  },
  parrafo: {
    textAlign: "justify",
    marginBottom: 6
  },
  bienesTable: {
    borderWidth: 1,
    borderColor: BORDE,
    marginTop: 4,
    marginBottom: 12
  },
  bienesTitulo: {
    fontFamily: "Helvetica-Bold",
    fontSize: 8.5,
    textAlign: "center",
    padding: 3,
    backgroundColor: "#e3e3ea",
    borderBottomWidth: 1,
    borderBottomColor: BORDE
  },
  bienesHeaderRow: {
    flexDirection: "row",
    backgroundColor: "#e3e3ea",
    borderBottomWidth: 1,
    borderBottomColor: BORDE
  },
  bienesRow: {
    flexDirection: "row",
    borderBottomWidth: 1,
    borderBottomColor: BORDE
  },
  bienesRowLast: {
    flexDirection: "row"
  },
  bienesHeaderText: { fontFamily: "Helvetica-Bold", textAlign: "center" },
  bienesCellNo: { ...celdaBien, width: "7%", textAlign: "center" },
  bienesCellBien: { ...celdaBien, width: "19%" },
  bienesCellSerial: { ...celdaBien, width: "15%", textAlign: "center" },
  bienesCellCantidad: { ...celdaBien, width: "11%", textAlign: "center" },
  bienesCellDescripcion: { ...celdaBien, width: "30%" },
  bienesCellObs: { ...celdaBien, width: "18%", borderRightWidth: 0 },
  clausulasLista: {
    marginBottom: 6,
    paddingLeft: 22
  },
  clausulaItem: {
    flexDirection: "row",
    marginBottom: 2
  },
  clausulaLetra: {
    width: 16
  },
  clausulaTexto: {
    flex: 1,
    textAlign: "justify"
  },
  firmasRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 46
  },
  firmaBox: {
    width: "31%",
    borderTopWidth: 1,
    borderTopColor: BORDE,
    paddingTop: 4
  },
  firmaLinea: {
    fontFamily: "Helvetica-Bold",
    fontSize: 9,
    marginBottom: 2
  },
  firmaTexto: {
    fontSize: 9
  }
});

export default actaStyles;
